module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Strada_Sdrucciolevole_per_Pioggia-CL.1db14438.svg";